
'use strict';

var _win = $(window);

var categories = function(){
    const stampati = {};

    for (const elemento of lista) {
    if (!stampati[elemento]) {
        $('.recipes-menu').find('ul').append('<li class="filter-recipe" data-cat='+ elemento.replaceAll(' ', '') + '>' + elemento + '</li>');
        stampati[elemento] = true;
    }
    }
}

$(document).on('click', '.filter-recipe' , function(){
    var filter = $(this).data('cat');
    
    if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.recipes-list-bound .slide').each(function(){
            $(this).show();
        });
    } else {
        $('.filter-recipe').removeClass('active');
        $(this).addClass('active');
        $('.recipes-list-bound .slide').each(function(){
            if ($(this).data('cat') == filter) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
   
} );

$(_win).on('load',function() {
    categories();
}); 